import { makePickFromUnion } from 'utils';
import { IVideo } from 'models';
import { IVideoUploadFile } from 'services/video-upload/state';

export const pickFromVideoOrFile = makePickFromUnion<IVideo, IVideoUploadFile>(
  (obj) => 'durationSeconds' in obj,
);
